<template>
  <v-tooltip bottom color="lightSecondary lighten-4" max-width="300">
    <template v-slot:activator="{ on }">
      <div v-on="on" class="d-flex align-center" v-bind:class="className" v-if="iso">
        <country-flag v-if="!size && showCountryFlag(iso)" :country="iso"  class="elevation-3" v-bind:style="{transform:`scale(${scale})`}" />
        <country-flag v-if="size && showCountryFlag(iso)" :country="iso"  class="elevation-3" :size="size"/>
        <img height="14" v-if="iso === 'latam'" class="" src="https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1160.png"/>
        <img height="14" v-if="iso === 'caf'" class="" src="https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1094.png"/>
        <img height="14" v-if="iso === 'int'" class="" src="https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/326.png"/>
        <img height="14" v-if="iso === 'eu'" class="" src="https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/327.png"/>
        <img height="14" v-if="iso === 'afc'" class="" src="https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1163.png"/>
        <img height="14" v-if="iso === 'concacaf'" class="" src="https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/1154.png"/>
      </div>
    </template>
    <span v-if="iso" class="black--text body-1">{{$t(`iso.${iso.toUpperCase()}`)}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "DriblabCountryFlag",
  props: {
    iso: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    scale: {
      type: Number,
      default: 0.35
    }
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    showCountryFlag(iso){
      const customFlags = ['latam', 'caf', 'int', 'eu', 'afc', 'concacaf'];
      return !customFlags.includes(iso);
    }
  }
};
</script>

<style lang="scss">
</style>
